<template>
  <div>
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">{{ $t(`apartment.${resident_type}title`) }}</h3>
      </div>

      <div class="box-body">
        <div class="row">
          <div class="col-sm-12">
            <b>{{ this.getFullNameByLanguage(null) }}</b> <br />
            <br />
            <div class="row">
              <div class="col-md-4 col-lg-4">
                <b>{{ $t("customer.username") }}:</b>
                {{
                  (resident_type == "tenant" ? tenant : main_person).resident
                    .username
                }}
                <br />
                <b>{{ $t("customer.fullname") }}:</b>
                {{ this.getFullNameByLanguage(null) }} <br />
                <b>{{ $t("customer.email") }}:</b>
                {{
                  (resident_type == "tenant" ? tenant : main_person).resident
                    .email
                }}
                <br />
                <b>{{ $t("customer.phone") }}:</b>
                {{
                  (resident_type == "tenant" ? tenant : main_person).resident
                    .phone
                }}
                <br />
                <b>{{ $t("customer.current_debt") }}:</b>
                {{ formatNumber(current_debt) }} vnđ <br />
              </div>
              <div class="col-md-4 col-lg-4">
                <b>{{ $t("customer.gender") }}:</b>
                {{
                  $t(
                    (resident_type == "tenant" ? tenant : main_person).resident
                      .gender
                  )
                }}
                <br />
                <b>{{ $t("customer.dob") }}:</b> {{ day_of_birth }} <br />
                <b>{{ $t("customer.country") }}:</b>
                {{
                  (resident_type == "tenant" ? tenant : main_person).resident
                    .country_name
                }}
                <br />
              </div>
              <div class="col-md-4 col-lg-4">
                <b>{{ $t("apartment.e_figure") }}:</b>
                {{
                  (resident_type == "tenant" ? tenant : main_person)
                    .start_efigure
                }}
                <br />
                <b>{{ $t("apartment.w_figure") }}:</b>
                {{
                  (resident_type == "tenant" ? tenant : main_person)
                    .start_wfigure
                }}
                <br />
                <b>{{ $t("apartment.move_in") }}:</b> {{ day_move_in }} <br />
                <b>{{ $t("apartment.move_out") }}:</b> {{ day_move_out }} <br />
              </div>
            </div>
          </div>
        </div>
        <br />
        <br />
        <div class="row">
          <div class="col-sm-12">
            <b>{{ $t("apartment.relatives") }}:</b> <br />
            <br />
            <div class="col-xs-12 table-responsive">
              <b-table
                :items="resident_items"
                :fields="resident_fields"
                class="mt-3"
                outlined
              >
                <template #head()="scope">
                  <div>{{ $t(scope.label) }}</div>
                </template>
                <template slot="actions" slot-scope="row">
                  <div class="btn-group">
                    <button
                      class="btn btn-primary"
                      style="margin-left: 6px;"
                      @click="onOpenEditRelative(row)"
                    >
                      <i class="glyphicon glyphicon-edit"></i>
                    </button>
                    <button
                      class="btn btn-danger"
                      style="margin-left: 6px;"
                      @click="onOpenDeleteRelative(row)"
                    >
                      <i class="glyphicon glyphicon-trash"></i>
                    </button>
                  </div>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
      <div class="box-footer">
        <button
          v-if="has_perm('update_apartment') || GET_ACCOUNT_DATA.id == 1"
          type="button"
          class="btn btn-labeled btn-success pull-right"
          style="margin-right: 5px;"
          @click="onOpenMainPersonRegistration"
        >
          <span class="btn-label">
            <i class="glyphicon glyphicon-edit"></i>
          </span>
          {{ $t(`apartment.edit${resident_type}`) }}
        </button>
        <button
          v-if="false"
          type="button"
          class="btn btn-labeled btn-info pull-right"
          style="margin-right: 5px;"
          @click="onOpenAddRelative"
        >
          <span class="btn-label">
            <i class="glyphicon glyphicon-plus"></i>
          </span>
          {{ $t("apartment.addrelative") }}
        </button>
      </div>
    </div>
    <!-- Modal Sửa Thông Tin Main Person -->
    <div class="modal fade" :ref="`modal-main-person-${resident_type}`">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">{{ $t("apartment.customer") }}</h4>
          </div>
          <div class="modal-body">
            <div class="row mb-1 margin-down-15" v-if="main_person.id !== 0">
              <div class="col-md-3">Thay Đổi Khách Hàng</div>
              <div class="col-md-6">
                <div class="form-group">
                  <div
                    class="radio custom-control-inline"
                    v-for="(option, index) in radioOptions"
                    :key="index"
                  >
                    <label>
                      <input
                        type="radio"
                        :value="option.value"
                        checked
                        name="updateNewMain"
                        v-model="updateNewMain"
                        :disabled="!is_debt_free"
                      />
                      {{ option.text }}
                    </label>
                  </div>
                  <br />
                  <span class="label label-warning" v-if="!is_debt_free">{{
                    $t("customer.msg_current_debt")
                  }}</span>
                </div>
              </div>
            </div>
            <div class="row mb-1 margin-down-15">
              <div class="col-md-3">{{ $t("apartment.customer") }}</div>
              <div style="margin-top:-16px;">
                <span v-if="updateNewMain || main_person.id === 0">
                  <lte-selectoptiontable
                    v-if="available_customers.length > 0"
                    :item="itemCustomer"
                    @onchangeselect="onChangeSelect"
                  ></lte-selectoptiontable>
                </span>
                <span class="col-md-6" v-else>
                  <input
                    type="text"
                    class="form-control"
                    :value="main_person_full_name"
                    readonly
                  />
                </span>
              </div>
            </div>

            <div class="row mb-1 margin-down-15">
              <div class="col-md-3">{{ $t("apartment.cycle") }}</div>
              <div class="col-md-6">
                <select
                  class="form-control"
                  v-model="main_person.period_selected"
                >
                  <option
                    v-for="(item, index) in main_person.periods_list_current"
                    :key="index"
                    :value="item.value"
                    >{{ item.text }}</option
                  >
                </select>
              </div>
            </div>

            <div class="row mb-1 margin-down-15">
              <div class="col-md-3">{{ $t("apartment.e_figure") }}</div>
              <div class="col-md-6">
                <input
                  :disabled="!is_debt_free"
                  v-model="main_person.update_start_efigure"
                  type="number"
                  class="form-control"
                />
              </div>
            </div>
            <div class="row mb-1 margin-down-15">
              <div class="col-md-3">{{ $t("apartment.w_figure") }}</div>
              <div class="col-md-6">
                <input
                  :disabled="!is_debt_free"
                  v-model="main_person.update_start_wfigure"
                  type="number"
                  class="form-control"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
              @click="onCancelMainPerson"
            >
              {{ $t("common.back") }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="onSaveMainPerson"
            >
              {{ $t("common.save") }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
    <!-- Modal Sửa Thông Tin Người Thân -->
    <div class="modal fade" :ref="`modal-relative-person-${resident_type}`">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">{{ $t("apartment.relative") }}</h4>
          </div>
          <div class="modal-body">
            <div class="row mb-1 margin-down-15">
              <div class="col-md-3">{{ $t("apartment.relative") }}</div>
              <div class="col-md-6">
                <b-form-select
                  :options="available_customers"
                  v-model="selected_relative_person.resident.id"
                  class="form-control"
                />
              </div>
            </div>
            <div class="row mb-1 margin-down-15">
              <div class="col-md-3">{{ $t("apartment.relationship") }}</div>
              <div class="col-md-6">
                <b-form-select
                  :options="relationshipOptions"
                  v-model="selected_relative_person.relationship"
                  class="form-control"
                />
              </div>
            </div>
            <div class="row mb-1 margin-down-15">
              <div class="col-md-3">
                {{ $t("apartment.relationship_note") }}
              </div>
              <div class="col-md-6">
                <input
                  v-model="selected_relative_person.relationship_note"
                  type="text"
                  class="form-control"
                />
              </div>
            </div>
            <div class="row mb-1 margin-down-15">
              <div class="col-md-3">{{ $t("apartment.resident_status") }}</div>
              <div class="col-md-6">
                <b-form-select
                  :options="residentStatusOptions"
                  v-model="selected_relative_person.resident_status"
                  class="form-control"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.cancel") }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="onSaveRelativePerson"
            >
              {{ $t("common.save") }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
    <!-- Modal Confirm Delete Relative -->
    <div class="modal fade" :ref="`modal-relative-delete-${resident_type}`">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">Xóa Người Phụ Thuộc</h4>
          </div>
          <div class="modal-body">Bạn Có Chắc Muốn Xóa Người Này?</div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.cancel") }}
            </button>
            <button
              type="button"
              class="btn btn-primary btn-green"
              @click="onDeleteRelative"
            >
              {{ $t("common.confirm") }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
//import datePicker from "vue-bootstrap-datetimepicker";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import constants from "@/lib/constantsData";
import i18n from "../../lang";
import utils from '@/lib/utils';
import SelectOptionTable from "@/components/SelectOptionTable.vue";

// Import EventBus.
//import { EventBus } from './event-bus.js';

export default {
  name: "MainContactDetails",
  props: {
    apartment_id: {
      type: Number,
      default: () => {
        return 0;
      }
    },
    apartment_code: {
      type: String,
      default: () => {
        return null;
      }
    },
    resident_type: {
      type: String,
      default: () => {
        return "owner";
      }
    }
  },
  data() {
    return {
      liability_search: {
        from_date: null,
        to_date: null,
        apartment_code: ""
      },
      main_person: {
        id: 0,
        resident: {
          id: null,
          first_name: "",
          last_name: "",
          email: "",
          username: "",
          phone: "",
          country_name: "",
          dob: null,
          gender: 0
        },
        resident_movein: null,
        resident_moveout: null,
        start_efigure: 0,
        start_wfigure: 0,
        update_start_efigure: 0,
        update_start_wfigure: 0,
        resident_status: null,
        available_customers: [],

        period_selected: 0,
        periods_list_current: []
      },
      tenant: {
        id: 0,
        resident: {
          id: 0,
          first_name: "",
          last_name: "",
          email: "",
          username: "",
          phone: "",
          country_name: "",
          dob: null,
          gender: 0
        },
        resident_movein: null,
        resident_moveout: null,
        start_efigure: 0,
        start_wfigure: 0,
        resident_status: null,
        available_customers: []
      },
      selected_relative_person: {
        id: 0,
        resident: {
          id: null,
          first_name: "",
          last_name: "",
          email: "",
          username: "",
          phone: "",
          country_name: "",
          dob: null,
          gender: 0
        },
        relationship: null,
        resident_status: null,
        relationship_note: null
      },
      residentStatusOptions: constants.residentStatusOptions,
      relationshipOptions: constants.relationshipOptions,
      dateOptions: {
        format: "DD/MM/YYYY"
      },
      customers: [],
      resident_items: [],
      resident_fields: [
        {
          key: "full_name",
          label: "apartment.fullname",
          sortable: true,
          class: "text-center"
        },
        {
          key: "phone",
          label: "apartment.phone",
          sortable: true,
          class: "text-center"
        },
        {
          key: "email",
          label: "apartment.email",
          sortable: true,
          class: "text-center"
        },
        {
          key: "country",
          label: "apartment.country",
          sortable: true,
          class: "text-center"
        },
        {
          key: "underAge",
          label: "customer.age",
          sortable: true,
          class: "text-center"
        },
        {
          key: "resident_status",
          label: "common.status",
          sortable: true,
          class: "text-center"
        },
        {
          key: "relationship",
          label: "apartment.relationship",
          sortable: true,
          class: "text-center"
        },
        {
          key: "relationship_note",
          label: "common.note",
          sortable: true,
          class: "text-center"
        },
        { key: "actions", label: "common.action", class: "text-center" }
      ],
      radioOptions: [
        { text: "Đổi", value: true },
        { text: "Không", value: false }
      ],
      isExistMonthlyUsage: false,
      updateNewMain: false,
      itemCustomer: {
        data_list: [],
        itemType: 0,
        showLabel: false,
        modifyFromPosition: "margin-top:-300px",
        cssClassSm1: "col-md-3",
        cssClassSm2: "col-sm-6",
        showAddNew: false
      },
      current_debt: 0
    };
  },
  watch: {
    GET_CURRENT_USAGE_DATA: function() {},

    GET_RESIDENT_DATA: function() {
      // get main person & relatives of main person
      let main_person = "";
      let tenant = "";
      let relatives = [];
      for (let i = 0, size = this.GET_RESIDENT_DATA.length; i < size; i++) {
        let resident = this.GET_RESIDENT_DATA[i];
        if (
          this.resident_type === "owner" &&
          (resident.isOwner == "Yes" || resident.isOwner == true)
        ) {
          main_person = resident;
        } else if (
          this.resident_type === "tenant" &&
          (resident.isTenant == "Yes" || resident.isTenant == true)
        ) {
          tenant = resident;
        }
        relatives.push(resident);
      }
      // refresh main person details
      if (!main_person) {
        main_person = {
          id: 0,
          resident: {
            id: null,
            first_name: "",
            last_name: "",
            email: "",
            username: "",
            phone: "",
            country_name: "",
            dob: null,
            identificationnumber: "",
            gender: 0
          },
          resident_movein: null,
          resident_moveout: null,
          start_efigure: 0,
          start_wfigure: 0,
          resident_status: null
        };
      } else if (!tenant) {
        tenant = {
          id: 0,
          resident: {
            id: 0,
            first_name: "",
            last_name: "",
            email: "",
            username: "",
            phone: "",
            country_name: "",
            dob: null,
            identificationnumber: "",
            gender: 0
          },
          resident_movein: null,
          resident_moveout: null,
          start_efigure: 0,
          start_wfigure: 0,
          resident_status: null
        };
      }
      this.getMainPerson(main_person);
      this.getTenant(tenant);
      // refresh relatives
      this.getRelatives(relatives);

      // Show select for cycle
      let data = this.GET_CURRENT_USAGE_DATA;
      this.main_person.update_start_efigure = data.e_value;
      this.main_person.update_start_wfigure = data.w_value;
      let is_enable_current_cycle = data.is_enable_current_cycle;
      let is_enable_next_cycle = data.is_enable_next_cycle;
      let periods_list = [];
      if (is_enable_current_cycle) {
        let item = {
          value: data.period_current.type_period,
          text:
            "Chu kì hiện tại (" +
            utils.formatSqlDate(data.period_current.date_from, null, "DD/MM") +
            "-" +
            utils.formatSqlDate(data.period_current.date_to, null, "DD/MM") +
            ")",
          period_current: data.period_current
        };

        periods_list.push(item);
      }
      if (is_enable_next_cycle) {
        let item = {
          value: data.period_next.type_period,
          text:
            "Chu kì tiếp theo (" +
            utils.formatSqlDate(data.period_next.date_from, null, "DD/MM") +
            "-" +
            utils.formatSqlDate(data.period_next.date_to, null, "DD/MM") +
            ")",
          period_next: data.period_next
        };
        this.main_person.period_selected = 1;
        periods_list.push(item);
      }

      if (is_enable_current_cycle) {
        this.main_person.period_selected = 0;
      }

      this.main_person.periods_list_current = periods_list;
      // END --- Show select for cycle
    },
    apartment_id: function() {
      let apartment_id = this.apartment_id;
      if (parseInt(apartment_id) !== 0) {
        this.getResidents(apartment_id);
      }
    },
    apartment_code: function() {
      this.onSearch(); // this is liability serach
    },
    APARTMENT_MONTHLY_USAGE_DATA: function() {
      for (
        let i = 0, size = this.APARTMENT_MONTHLY_USAGE_DATA.length;
        i < size;
        i++
      ) {
        let monthlyUsage = utils.formatSqlDate(this.APARTMENT_MONTHLY_USAGE_DATA[i].date_to, null, "MM/YYYY");
        let monthNow = moment(new Date()).format("MM/YYYY");
        //Check disable if exist monthly usage > month now
        if (monthlyUsage < monthNow) {
          this.isExistMonthlyUsage = true;
          break;
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      "GET_RESIDENT_DATA",
      "GET_SNACK_BAR",
      "APARTMENT_MONTHLY_USAGE_DATA",
      "GET_ACCOUNT_DATA",
      "GET_CURRENT_USAGE_DATA"
    ]),
    day_of_birth: function() {
      return utils.formatSqlDate((this.resident_type == "tenant" ? this.tenant : this.main_person).resident.dob, null, this.dateOptions.format);
    },
    day_move_in: function() {
      return utils.formatSqlDate((this.resident_type == "tenant" ? this.tenant : this.main_person).resident_movein, null, this.dateOptions.format);
    },
    day_move_out: function() {
      return utils.formatSqlDate((this.resident_type == "tenant" ? this.tenant : this.main_person).resident_moveout, null, this.dateOptions.format);
    },
    available_customers: function() {
      let available_customers = [];
      for (let i = 0; i < this.customers.length; i++) {
        let customer = this.customers[i];
        let exist_ind = false;
        for (let j = 0; j < this.GET_RESIDENT_DATA.length; j++) {
          let resident = this.GET_RESIDENT_DATA[j];
          if (resident.resident.id === customer.value) {
            exist_ind = true;
          }
        }
        if (!exist_ind) {
          available_customers.push(customer);
        }
      }
      this.setAvailableCustomers(available_customers);
      return available_customers;
    },
    main_person_full_name: function() {
      if (utils.isEnglishLanguage(i18n.locale)) {
        return `${
          (this.resident_type == "tenant" ? this.tenant : this.main_person)
            .resident.first_name
        } ${
          (this.resident_type == "tenant" ? this.tenant : this.main_person)
            .resident.last_name
        }`;
      } else {
        return `${
          (this.resident_type == "tenant" ? this.tenant : this.main_person)
            .resident.last_name
        } ${
          (this.resident_type == "tenant" ? this.tenant : this.main_person)
            .resident.first_name
        }`;
      }
    },
    is_debt_free: function() {
      if (parseInt(this.current_debt) != 0) {
        return false;
      }
      return true;
    }
  },
  methods: {
    ...mapActions([
      "GET_RESIDENT_LIST",
      "GET_CUSTOMER_LIST",
      "ADD_RESIDENT",
      "UPDATE_RESIDENT",
      "GET_RESIDENT_DETAIL",
      "DELETE_RESIDENT",
      "ON_SHOW_TOAST",
      "SUCCESS_TOAST",
      "GET_APARTMENT_MONTHLY_USAGE",
      "GET_CURRENT_USAGE"
    ]),
    ...mapActions("accountingHomeLiabilityModule", [
      "SEARCH_ACCOUNTING_HOME_LIABILITY_LIST_DETAIL",
      "SEARCH_ACCOUNTING_HOME_LIABILITY_LIST"
    ]),
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    formatNumber: function(n) {
      if (n !== null || n !== 0) {
        return utils.formatNumber(n);
      }
      return 0;
    },
    // START: công nợ actions
    initializeLiabilityData() {
      this.liability_search.from_date = moment(new Date(), this.dateOptions.format).format("DD/MM/YYYY");
      this.liability_search.to_date = moment(new Date(), this.dateOptions.format).format("DD/MM/YYYY");
      this.liability_search.apartment_code = this.apartment_code;
    },
    onSearch() {
      this.initializeLiabilityData();
      let from_date = utils.formatSqlDate(this.liability_search.from_date, this.dateOptions.format, "DD/MM/YYYY hh:mm:ss");
      let to_date = utils.formatSqlDate(this.liability_search.to_date, this.dateOptions.format, "DD/MM/YYYY hh:mm:ss");

      if (utils.isNull(this.liability_search.apartment_code)) {
        return;
      }
      const data = {
        from_date: from_date,
        to_date: to_date,
        apartment_code: this.liability_search.apartment_code
      };
      //this.get_search_accounting_home_liability_list_detail(data)
      this.get_search_accounting_home_liability_list(data);
    },
    // get_search_accounting_home_liability_list_detail(data){
    //   this.isLoading = true;
    //   this.SEARCH_ACCOUNTING_HOME_LIABILITY_LIST_DETAIL(data)
    //     .then(
    //       function(res) {
    //         this.search_result_detail = res.data;
    //         this.isLoading = false;
    //       }.bind(this)
    //     )
    //     .catch(
    //       function(error) {
    //         this.isLoading = false;
    //         // check input error
    //         this.ON_SHOW_TOAST({
    //           message: "ERROR",
    //           styleType: "danger"
    //         });
    //       }.bind(this)
    //     );
    // },
    get_search_accounting_home_liability_list(data) {
      this.SEARCH_ACCOUNTING_HOME_LIABILITY_LIST(data)
        .then(
          function(res) {
            if (res.data.length > 0) {
              let debt = res.data[0].closing_trade_payable_max;
              this.current_debt = utils.makeRoundNumber(debt);
            }
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
            // check input error
            this.ON_SHOW_TOAST({
              message: "ERROR",
              styleType: "danger"
            });
          }.bind(this)
        );
    },
    // END: công nợ actions
    getFullNameByLanguage(data) {
      if (data != null) {
        return utils.getFullName(data.first_name, data.last_name, i18n.locale);
      } else {
        return utils.getFullName(
          (this.resident_type == "tenant" ? this.tenant : this.main_person)
            .resident.first_name,
          (this.resident_type == "tenant" ? this.tenant : this.main_person)
            .resident.last_name,
          i18n.locale
        );
      }
    },
    relative_status_name: function(status_id) {
      for (let i = 0; i < this.residentStatusOptions.length; i++) {
        let status = this.residentStatusOptions[i];
        if (status.value === status_id) {
          return status.text;
        }
      }
      return status_id;
    },
    getRelationshipName: function(status_id) {
      return utils.getRelationshipName(status_id)
    },
    onOpenMainPersonRegistration() {
      // reset radio option
      this.updateNewMain = false;
      $(this.$refs[`modal-main-person-${this.resident_type}`]).modal("show");
    },
    onOpenAddRelative() {
      $(this.$refs[`modal-relative-person-${this.resident_type}`]).modal(
        "show"
      );
      // reset data
      this.selected_relative_person = {
        id: 0,
        resident: {
          id: null,
          first_name: "",
          last_name: "",
          email: "",
          username: "",
          phone: "",
          country_name: "",
          dob: null
        },
        relationship: null,
        resident_status: null,
        relationship_note: null
      };
    },
    onCancelMainPerson() {
      let apartment_id = this.apartment_id;
      this.getResidents(apartment_id);
    },
    onSaveMainPerson() {
      let main_person_id = this.main_person.id;
      let tenant_id = this.tenant.id;
      if (
        this.main_person.resident.id == null ||
        this.main_person.resident.id == undefined ||
        this.main_person.resident.id == 0
      ) {
        let data = {
          message: "No Main Person",
          styleType: "danger"
        };
        this.ON_SHOW_TOAST(data);
        return;
      }
      if (this.updateNewMain || this.main_person.id === 0) {
        // current date for move in when new or change
        this.main_person.resident_movein = moment(new Date()).format("YYYY-MM-DDThh:mm:ss");
      }
      let data = {
        isMainContact: true,
        isOwner: this.resident_type === "owner" ? true : false,
        isTenant: this.resident_type === "tenant" ? true : false,
        resident_movein: utils.formatSqlDate(this.main_person.resident_movein, null, "YYYY-MM-DDThh:mm:ss"),
        resident_moveout: utils.formatSqlDate(this.main_person.resident_moveout, null, "YYYY-MM-DDThh:mm:ss"),
        start_efigure: this.main_person.update_start_efigure,
        start_wfigure: this.main_person.update_start_wfigure,
        resident_status: this.main_person.residence_status,
        relationship: null,
        relationship_note: null,
        apartment: parseInt(this.apartment_id),
        resident: this.main_person.resident.id,
        relationship_to: null,
        period_selected: {
          period_selected: this.main_person.period_selected,
          period_data: this.main_person.periods_list_current.filter(
            item => item.value == this.main_person.period_selected
          )[0]
        }
      };

      if (utils.isNull(main_person_id) && utils.isNull(main_person_id)) {
        this.addResident({ data: data });
      } else {
        this.updateResident({
          id: main_person_id === 0 ? tenant_id : main_person_id,
          data: data
        });
      }
      $(this.$refs[`modal-main-person-${this.resident_type}`]).modal("hide");
    },
    onSaveRelativePerson() {
      let selected_relative_id = this.selected_relative_person.id;
      if (this.main_person.resident.id == null) {
        let data = {
          message: "No Main Person",
          styleType: "danger"
        };
        this.ON_SHOW_TOAST(data);
        return;
      }
      let data = {
        isMainContact: false,
        isOwner: false,
        isTenant: false,
        resident_movein: null,
        resident_moveout: null,
        start_efigure: null,
        start_wfigure: null,
        resident_status: this.selected_relative_person.resident_status,
        relationship: this.selected_relative_person.relationship,
        relationship_note: this.selected_relative_person.relationship_note,
        apartment: parseInt(this.apartment_id),
        resident: this.selected_relative_person.resident.id,
        relationship_to: this.main_person.resident.id
      };
      if (selected_relative_id === 0) {
        this.addResident({ data: data });
      } else {
        this.updateResident({ id: selected_relative_id, data: data });
      }
      $(this.$refs[`modal-relative-person-${this.resident_type}`]).modal(
        "hide"
      );
    },
    addResident(payload) {
      this.ADD_RESIDENT({ data: payload.data })
        .then(
          function(res) {
            this.SUCCESS_TOAST();
            let apartment_id = this.apartment_id;
            this.getResidents(apartment_id);
            this.$emit("mainperson-save", {});
          }.bind(this)
        )
        .catch(
          function() {
            //this.ERROR_TOAST();
            this.getResidents(apartment_id);
          }.bind(this)
        );
    },
    updateResident(payload) {
      this.UPDATE_RESIDENT({ id: payload.id, data: payload.data })
        .then(
          function(res) {
            this.SUCCESS_TOAST();
            let apartment_id = this.apartment_id;
            this.getResidents(apartment_id);
            this.$emit("mainperson-save", {});
          }.bind(this)
        )
        .catch(
          function(error) {
            let data = {
              message: error.response.data.msg,
              styleType: "danger"
            };
            this.ON_SHOW_TOAST(data);
            let apartment_id = this.apartment_id;
            this.getResidents(apartment_id);
          }.bind(this)
        );
    },
    getResidents(apartment_id) {
      const apartmentdata = {
        params: {
          apartment: apartment_id
        }
      };
      this.GET_RESIDENT_LIST(apartmentdata).then(function() {}.bind(this));
    },
    //Get main person
    getMainPerson(main_person) {
      this.main_person = {
        id: main_person.id,
        resident: {
          id: main_person.resident.id,
          first_name: main_person.resident.first_name,
          last_name: main_person.resident.last_name,
          email: main_person.resident.email,
          username: main_person.resident.username,
          phone: main_person.resident.phone,
          gender:
            main_person.resident.gender !== 0
              ? main_person.resident.gender == 1
                ? "customer.gender_type[0]"
                : main_person.resident.gender == 2
                ? "customer.gender_type[1]"
                : "customer.gender_type[2]"
              : "",
          country_name: main_person.resident.country_name,
          dob: main_person.resident.dob,
          identificationnumber:
            main_person.resident.identificationnumber &&
            main_person.resident.identificationnumber
        },
        resident_movein: main_person.resident_movein,
        resident_moveout: main_person.resident_moveout,
        start_efigure: main_person.start_efigure,
        start_wfigure: main_person.start_wfigure,
        resident_status: main_person.resident_status
      };
      this.$emit("customer", { customer: this.main_person.resident });
    },
    //Get tenant
    getTenant(tenant) {
      this.tenant = {};
      this.tenant = {
        id: tenant.id,
        resident: {
          id: tenant.resident && tenant.resident.id,
          first_name: tenant.resident && tenant.resident.first_name,
          last_name: tenant.resident && tenant.resident.last_name,
          email: tenant.resident && tenant.resident.email,
          username: tenant.resident && tenant.resident.username,
          phone: tenant.resident && tenant.resident.phone,
          gender:
            tenant.resident && tenant.resident.gender !== 0
              ? tenant.resident && tenant.resident.gender == 1
                ? "customer.gender_type[0]"
                : tenant.resident && tenant.resident.gender == 2
                ? "customer.gender_type[1]"
                : "customer.gender_type[2]"
              : "",
          country_name: tenant.resident && tenant.resident.country_name,
          dob: tenant.resident && tenant.resident.dob,
          identificationnumber:
            tenant.resident && tenant.resident.identificationnumber
        },
        resident_movein: tenant && moment.utc(tenant.resident_movein, "DD/MM/YYYY").format(),
        resident_moveout: tenant.resident_moveout,
        start_efigure: tenant.resident && tenant.start_efigure,
        start_wfigure: tenant.resident && tenant.start_wfigure,
        resident_status: tenant.resident && tenant.resident_status
      };
    },
    getRelatives(relatives) {
      let resident_items = [];
      relatives.forEach(relative => {
        // check if relatives of main person
        if (
          relative != undefined &&
          this.main_person != undefined &&
          relative.relationship_to != undefined &&
          this.main_person.resident != undefined &&
          relative.relationship_to.id !== this.main_person.resident.id
        ) {
          return;
        }
        if (!relative.isOwner || relative.isOwner === "No") {
          let full_name = `${relative.resident.last_name} ${
            relative.resident.first_name
          }`;
          let phone = relative.resident.phone;
          let email = relative.resident.email;
          let country_name = relative.resident.country_name;
          let age = relative.resident.dob ? moment().diff(relative.resident.dob, "years") : 0;
          let underAge = age;
          let resident_status = this.relative_status_name(relative.resident_status);
          let relationship = this.getRelationshipName(relative.relationship);
          let relationship_note = relative.relationship_note;
          let item = {
            id: relative.id,
            full_name: full_name,
            phone: phone,
            email: email,
            country_name: country_name,
            underAge: underAge,
            relationship: relationship,
            resident_status: resident_status,
            relationship_note: relationship_note
          };
          resident_items.push(item);
        }
      });
      this.resident_items = resident_items;
    },
    onOpenEditRelative(row) {
      $(this.$refs[`modal-relative-person-${this.resident_type}`]).modal(
        "show"
      );
      this.GET_RESIDENT_DETAIL({ id: row.item.id }).then(
        function(res) {
          let resident_detail = res.data;
          this.selected_relative_person = {
            id: resident_detail.id,
            resident: {
              id: resident_detail.resident.id,
              first_name: resident_detail.resident.first_name,
              last_name: resident_detail.resident.last_name,
              email: resident_detail.resident.email,
              username: resident_detail.resident.username,
              phone: resident_detail.resident.phone,
              country_name: resident_detail.resident.country_name,
              dob: resident_detail.resident.dob
            },
            relationship: resident_detail.relationship,
            resident_status: resident_detail.resident_status,
            relationship_note: resident_detail.relationship_note
          };
        }.bind(this)
      );
    },
    onOpenDeleteRelative(row) {
      $(this.$refs[`modal-relative-delete-${this.resident_type}`]).modal(
        "show"
      );
      this.deleteRelativeId = row.item.id;
    },
    onDeleteRelative() {
      this.DELETE_RESIDENT({ id: this.deleteRelativeId }).then(
        function() {
          let apartment_id = this.apartment_id;
          this.getResidents(apartment_id);
          $(this.$refs[`modal-relative-delete-${this.resident_type}`]).modal(
            "hide"
          );
        }.bind(this)
      );
    },
    onChangeSelect: function(type_value) {
      this.main_person.resident.id = type_value;
      this.$emit("customer", { customer: this.main_person.resident });
      // this.assetdata.type = type_value;
      // this.itemAssetSubType.itemType = type_value;
      // this.itemAssetSubType.onItemChange = true;
      //TO DO
    },
    setAvailableCustomers: function(data) {
      if (data !== undefined) {
        this.itemCustomer.data_list = data;
      }
    }
  },
  mounted() {
    this.onSearch();
    this.GET_CUSTOMER_LIST().then(
      function(res) {
        let customerList = res.data;
        let customers = [{ value: null, text: "---" }];
        customerList.forEach(data => {
          let full_name = this.getFullNameByLanguage(data);
          let item = {
            value: data.id,
            text: full_name,
            email: data.email,
            dob: data.profile ? utils.formatSqlDate(data.profile.dob, null, "DD/MM/YYYY") : null,
            phone: data.profile ? data.profile.phone : null,
            passport: data.profile ? data.profile.passport : null
          };
          customers.push(item);
        });
        this.customers = customers;
        let apartment_id = this.apartment_id;
        if (parseInt(apartment_id) !== 0) {
          this.getResidents(apartment_id);
        }
      }.bind(this)
    );
    //Get apartment monthly usage
    const filter = {
      params: {
        page: 1,
        apartmentid: this.$route.params.id
      }
    };
    this.GET_APARTMENT_MONTHLY_USAGE(filter).then(function(res) {}.bind(this));

    //Get period current
    const filter_period_current = {
      params: {
        apartment_id: this.$route.params.id,
        current_local_pc_time: moment(new Date(), "DD-MM-YYYY").format("DD/MM/YYYY")
      }
    };
    this.GET_CURRENT_USAGE(filter_period_current).then(
      function(res) {}.bind(this)
    );
  },
  components: {
    //"date-picker": datePicker,
    "lte-core-alert": LTECoreAlert,
    "lte-selectoptiontable": SelectOptionTable
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.margin-down-15 {
  margin-bottom: 15px;
}

.row {
  margin-right: 0px;
  margin-left: 0px;
}

.custom-control-inline {
  display: inline-flex;
  margin-right: 1rem;
}

.label-red {
  background-color: red !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Apartment/MainContactDetails.vue